import React, { useContext, useState } from 'react';
import { Button, InputDescription, Modal, Toast } from '../../uiComponents/common';
import { WelletContext } from '../../context/wellet/welletContext';
import { useMutation } from 'react-query';
import { postConfirmRejectReservation } from '../../services';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Show } from '../../components';

const ModalConfirmation = ({ onClose, handleSubmit, reservation, language, reservationType }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'modals.modalConfimration' });
  const welletContext = useContext(WelletContext);

  const [openConfirm, setOpenConfirm] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [openError, setOpenError] = useState(false);

  const methods = useForm({
    defaultValues: {
      reason: null,
    },
  });

  // API Querys
  const confirmMutation = useMutation({
    mutationFn: (data) => {
      return postConfirmRejectReservation(welletContext, {
        reservationId: reservation?.id,
        isConfirm: data.isConfirm,
        reason: data?.reason,
      });
    },
    onSuccess: (data) => {
      if (data.data) {
        setOpenDetail(true);
      } else {
        setOpenError(true);
      }
    },
  });

  // Functions
  const handleModalConfirm = () => {
    setOpenConfirm((prevState) => !prevState);
  };
  const handleModalDetail = () => {
    setOpenDetail((prevState) => !prevState);
  };
  const handleToastError = () => {
    setOpenError((prevState) => !prevState);
  };
  const handleCloseConfirm = () => {
    handleModalConfirm();
    methods.reset({
      reason: null,
    });
  };
  const handleClose = () => {
    handleModalDetail();
    onClose();
    handleCloseConfirm();
    handleToastError();
    methods.reset({
      reason: null,
    });
  };
  const onSubmit = (data) => {
    const body = {
      isConfirm: true,
      reason: data.reason,
    };

    return confirmMutation.mutate(body);
  };

  const isGroup = reservationType === 'GROUP';

  return (
    <>
      <Button
        className={'btn-wellet-secondary bg-custom-light text-truncate btn-accept'}
        onClick={handleModalConfirm}
        size={'custom'}
        text={
          <>
            <span className='dot dot-green mr-2 d-inline-block'></span>
            {isGroup ? t('btnQuotation') : t('btnConfirmOPT')}
          </>
        }
      />
      <Show.When isTrue={openConfirm && !openDetail}>
        <FormProvider {...methods}>
          <Modal
            title={isGroup ? t('titleGroup') : t('title')}
            open={openConfirm && !openDetail}
            onClose={handleCloseConfirm}
            maxWidth='450px'
            closeIcon={true}
            handleSubmit={handleSubmit}
            closeOnDocumentClick={false}
            customButtons={
              <>
                <div className='row px-2 text-center'>
                  <Button
                    text={t('btnCancel')}
                    disabled={confirmMutation.isLoading}
                    className={'col btn-general btn-wellet-secondary'}
                    size={'medium'}
                    onClick={handleCloseConfirm}
                  />
                  <Button
                    text={isGroup ? t('btnGroup') : t('btnConfirm')}
                    disabled={confirmMutation.isLoading}
                    className={'col ml-2 btn-general btn-wellet-primary'}
                    size={'medium'}
                    onClick={() => methods.handleSubmit(onSubmit)()}
                  />
                </div>
              </>
            }
          >
            <div className='text-left mt-2'>
              <div>{isGroup ? t('askGroup') : t('ask')}</div>
            </div>
            <div className='row p-0'>
              <InputDescription
                maxLength={512}
                height='75px'
                label={t('label')}
                name={'reason'}
                isDisabled={confirmMutation.isLoading}
                placeholder={`${t('placesholder')} (${language})`}
                isRequired={false}
                minLength={0}
                dropdown={true}
                className='col pt-2 pb-0'
              />
            </div>
          </Modal>
        </FormProvider>
      </Show.When>

      <Show.When isTrue={openDetail}>
        <Modal
          title={isGroup ? t('titleConfirmGroup') : t('titleConfirm')}
          open={openDetail}
          onClose={handleClose}
          maxWidth='450px'
          closeIcon={true}
          handleSubmit={handleSubmit}
          closeOnDocumentClick={false}
          customButtons={
            <div className='w-100 d-flex justify-content-center'>
              <Button
                text={t('btnClose')}
                onClick={handleClose}
                className={'btn-general btn-wellet-secondary'}
                size={'medium'}
                width={'60px'}
              />
            </div>
          }
        >
          <div className='my-3 text-center d-flex flex-column'>
            <span style={{ color: 'var(--color-text-sidebar)' }}>
              {isGroup ? t('quotation') : t('reservation')}
            </span>
            <span
              className='font-weight-bold'
              style={{ fontSize: '26px', color: 'var(--color-text-sidebar)', lineHeight: 1 }}
            >
              {reservation?.referenceCode}
            </span>
            <span style={{ color: 'var(--color-text-sidebar)' }}>
              {' '}
              {isGroup ? t('hasSent') : t('hasConfirmed')}
            </span>
          </div>
        </Modal>
      </Show.When>

      <Show.When isTrue={openError}>
        <Toast
          message={t('toast')}
          type={`ERROR`}
          onCallback={() => {
            handleClose();
          }}
        />
      </Show.When>
    </>
  );
};

export default ModalConfirmation;
